namespace AgerLMS.CMS {
    export interface CmsPageRow {
        PageId?: number;
        Header?: string;
        Details?: string;
        PageRate?: number;
        PageType?: PageTypes;
        Seo?: string;
        PagePicture?: string;
        Summary?: string;
        Keywords?: string;
        PageHeader?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace CmsPageRow {
        export const idProperty = 'PageId';
        export const nameProperty = 'Header';
        export const localTextPrefix = 'CMS.CmsPage';
        export const deletePermission = 'LMS:CmsPage:Modify';
        export const insertPermission = 'LMS:CmsPage:Modify';
        export const readPermission = 'LMS:CmsPage:Read';
        export const updatePermission = 'LMS:CmsPage:Modify';

        export declare const enum Fields {
            PageId = "PageId",
            Header = "Header",
            Details = "Details",
            PageRate = "PageRate",
            PageType = "PageType",
            Seo = "Seo",
            PagePicture = "PagePicture",
            Summary = "Summary",
            Keywords = "Keywords",
            PageHeader = "PageHeader",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
